export const isAcme = process.env.PROJECT === 'acme';
export const isQuicken = !isAcme;
export default isAcme;
